import { action } from "satcheljs";

export const importJobSchedule = action("importJobSchedule",
    (teamId: string, file: File ) => ({ teamId: teamId, file: file })
);